import { useParams } from "react-router-dom";

export const useProjectId = () => {
	const { projectId } = useParams<{ projectId: string }>();

	if (!projectId) {
		throw new Error("projectId is required in URL params");
	}

	return { projectId };
};
